import React, { useState, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { T } from '../theme';
import { MultiSelect, DoneToggle } from '../components/Bits';
import Scorecards from '../components/Scorecards';
import TaskTable from '../components/TaskTable';
import CreateTaskModal from '../components/CreateTaskModal';
import TaskDetailModal from '../components/TaskDetailModal';
import { useLookups, useBoard } from '../usePm';

export default function Overview() {
  const { user } = useAuth();
  const { brands, users, types } = useLookups();
  const { buckets, score, loading, filters, setFilters, showDone, setShowDone, reload, patch } = useBoard({});
  const [openTask, setOpenTask] = useState(null);
  const [creating, setCreating] = useState(false);
  const incompleteRef = useRef(null);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 22 }}>
        <div>
          <h1 style={{ color: T.text, fontSize: 26, margin: 0 }}>Hoş geldin, {user?.name?.split(' ')[0] || user?.name} 👋</h1>
          <div style={{ color: T.muted, fontSize: 14, marginTop: 4 }}>Görev genel bakışı{user?.role === 'admin' ? ' (tüm ekip)' : ' (sana ait)'}</div>
        </div>
        <button onClick={() => setCreating(true)} style={{ padding: '10px 18px', background: T.blueDark, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>+ Yeni Görev</button>
      </div>

      <Scorecards data={score} onIncompleteClick={() => incompleteRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })} />

      <div style={{ display: 'flex', gap: 12, marginBottom: 18, flexWrap: 'wrap' }}>
        <MultiSelect single label="Assignee" options={users.map(u => ({ id: u.id, label: u.name }))} value={filters.assignee} onChange={v => setFilters(f => ({ ...f, assignee: v }))} placeholder="Herkes" />
        <MultiSelect single label="Marka" options={brands.map(b => ({ id: b.id, label: b.brand_name || b.company_name }))} value={filters.brand} onChange={v => setFilters(f => ({ ...f, brand: v }))} placeholder="Tümü" />
        <MultiSelect single label="Task Type" options={types.map(t => ({ id: t.id, label: t.name }))} value={filters.type} onChange={v => setFilters(f => ({ ...f, type: v }))} placeholder="Tümü" />
      </div>

      <TaskTable title="⏳ Due Date Yaklaşan (3 gün)" tasks={buckets.upcoming} loading={loading} onPatch={patch} onOpen={setOpenTask} />
      <TaskTable title="🔴 Gecikmiş" tasks={buckets.overdue} loading={loading} onPatch={patch} onOpen={setOpenTask} />
      <TaskTable title="🔵 Devam Ediyor · Due Date Yok" tasks={buckets.inprogress_no_due} loading={loading} onPatch={patch} onOpen={setOpenTask} />

      <div ref={incompleteRef} style={{ scrollMarginTop: 16 }}>
        <TaskTable
          title="📋 Tamamlanmamış Görevler"
          titleRight={<DoneToggle checked={showDone} onChange={setShowDone} />}
          tasks={buckets.incomplete} loading={loading} onPatch={patch} onOpen={setOpenTask}
        />
      </div>

      {creating && <CreateTaskModal brands={brands} users={users} types={types} onClose={() => setCreating(false)} onCreated={reload} />}
      {openTask && <TaskDetailModal taskId={openTask.id} brands={brands} users={users} types={types} onClose={() => setOpenTask(null)} onChanged={reload} />}
    </div>
  );
}
